import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalHeader, Row, Spinner, Table } from 'reactstrap';
import BreadCrumb from '../../Common/BreadCrumb';
import { GlobalStore } from '../../../StateStores';
import { getInvoiceList } from '../../../Actions/InvoiceActs';
import { toast } from 'react-toastify';
import DateFilter from '../../Common/DateFilter';
import moment from 'moment';
import ControlNumberManager from './ControlNumberManager';
import FireArmDetails from '../FireArm/FireArmDetails';

const InvoiceList = ({serviceType})=>{
    const [modal, setModal] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment());
    const [selectedInvoice, setSelectedInvoice] = useState({});
    const [selectedService, setSelectedService] = useState("");
    const [paymentstatus, setPaymentstatus] = useState("UNPAID");

    const {InvoiceDispatch,InvoiceState:{
        getInvoices:{error,loading,data},
    }} = useContext(GlobalStore);

    const loadInvoices = async ()=>{
        try {
            const response = await getInvoiceList({
                payment:paymentstatus || 'UNPAID',
                fromdate: startDate?.format('YYYY-MM-DD'),
                todate: endDate?.format('YYYY-MM-DD'),
                serviceType
            })(InvoiceDispatch)
            if(response.status){
                setInvoices(response.data)
            }
        } catch (error) {
            toast.error(error.message)
        }
    }

    useEffect(()=>{
        loadInvoices();
    },[paymentstatus, startDate, endDate])

    const onChangePayment = (type) => {
        setPaymentstatus(type)
    }

    const togOpenModal = ()=>{
        setModal(!modal);
    }

    const modalHandler = (transaction,service)=>{
        setSelectedService(service)
        togOpenModal();
        setSelectedInvoice(transaction)
    }

    return(
        <React.Fragment>

            <Modal size='md' isOpen={modal}  toggle={() => { togOpenModal() }}>
                <ModalHeader toggle={() => { togOpenModal() }}>{selectedService}</ModalHeader>
                <ModalBody className="bg-light">
                    {selectedService === 'Control number' && <ControlNumberManager toggleModal={togOpenModal} transaction={selectedInvoice}/>}
                    {selectedService === 'Firearm details' && <FireArmDetails toggleModal={togOpenModal} transaction={selectedInvoice}/>}
                </ModalBody>
            </Modal>

            <div className='mt-5'>
                <BreadCrumb title={`${serviceType == 11? 'Vehicle':'Firearm'} Tansaction List`} pageTitle="Transaction"/>
                <Card className='shadow-sm'>
                    <CardHeader tag="div">
                        <Row>
                            <Col>
                                <DateFilter 
                                    startDate={startDate}
                                    endDate={endDate}
                                    onDatesChange={({ startDate, endDate }) => {
                                        setStartDate(startDate);
                                        setEndDate(endDate);
                                    }}
                                />
                            </Col>
                            <Col>
                                <Input 
                                    type='select'
                                    value={paymentstatus}
                                    onChange={(e) => onChangePayment(e.target.value)}
                                >
                                    {/* <option value="">All</option> */}
                                    <option value="PAID">PAID</option>
                                    <option value="UNPAID">UNPAID</option>
                                </Input>
                            </Col>
                            <Col>
                                {/* <Button><span className='ri-search-line'></span> Filter</Button>  */}
                                <Button onClick={loadInvoices} className='ms-1'><span className='ri-refresh-line'></span> Refresh</Button></Col>
                            <Col></Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Table bordered size="sm" className='caption-top'>
                            <caption>
                                {loading && <Spinner size="sm"/>}
                            </caption>
                            <thead className="bg-light">
                                <tr>
                                    <th>#</th>
                                    <th>Transaction#</th>
                                    {serviceType === 11 && (
                                        <React.Fragment>
                                            <th>Owner</th>
                                            <th>Reg number</th>
                                            <th>Vehicle</th>
                                        </React.Fragment>
                                    )}

                                    {serviceType === 1 && (
                                        <React.Fragment>
                                            <th>Type</th>
                                            <th>Police Station</th>
                                            <th>Group / Company</th>
                                        </React.Fragment>
                                    )}

                                    <th className='text-center'>Control Number</th>
                                    <th className='text-center'>Amount</th>
                                    <th className='text-center'>Bill Status</th>
                                    <th className='text-center'>Payment</th>
                                    <th className='text-center'>Creation Date</th>
                                    <th className='text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(invoices || []).map((invoice,index)=>(
                                    <tr>
                                        <td>{++index}</td>
                                        <td>{invoice?.trans_code}</td>
                                        {serviceType === 11 && (
                                            <React.Fragment>
                                                <td>{invoice?.customer_name}</td>
                                                <td>{invoice?.registration_number}</td>
                                                <td>{invoice?.vehicle}</td>
                                            </React.Fragment>
                                        )}

                                        {serviceType === 1 && (
                                            <React.Fragment>
                                                <td>{invoice?.fireTransType}</td>
                                                <td>{invoice?.police_station}</td>
                                                <td>{invoice?.group_company_name}</td>
                                            </React.Fragment>
                                        )}

                                        <td>{invoice?.trans_control_no}</td>
                                        <td>{invoice?.trans_amount}</td>
                                        <td>{invoice?.trans_bill_status}</td>
                                        <td>
                                            <div>
                                                <div className='text-primary text-capitalize'>{invoice?.trans_status}</div>
                                                {invoice?.trans_pay_receipt && <div><small className='text-black'>{invoice?.trans_pay_receipt}</small></div>}
                                                {invoice?.trans_pay_channel && <div><small className='text-black'>{invoice?.trans_pay_channel}</small></div>}
                                            </div>
                                        </td>
                                        <td className='text-center'>{moment(invoice?.trans_created_at).format('YYYY-MM-DD')}</td>
                                        <td>

                                            {invoice?.trans_bill_status !== 'POSTED' && (
                                                <Button 
                                                    size='sm' 
                                                    title='Request control number'
                                                    onClick={(e)=>{
                                                    modalHandler(invoice,'Control number')
                                                }}>
                                                   <span className='ri-folder-settings-line'></span>
                                                </Button>
                                            )}

                                            {serviceType === 1 && (
                                                <Button 
                                                    size='sm' 
                                                    className='ms-1'
                                                    title='Firearm details / users'
                                                    color='success'
                                                    onClick={(e)=>{
                                                        modalHandler(invoice, 'Firearm details')
                                                }}>
                                                   <span className='ri-team-line'></span>
                                                </Button>
                                            )}

                                            {invoice?.trans_bill_status === 'POSTED' && (
                                                <span className='ri-spam-line'></span>
                                            )}

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </div>
        </React.Fragment>
    )
}

export default InvoiceList;